import React from "react";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import useDebugInformation from "../../../../../hooks/useDebugInformation";
import Version from "@utils/version";

type Props = {}

const Copyright: React.FC<Props> = () => {

    useDebugInformation("Copyright", {})
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            {new Date().getFullYear() + " "}
            <Link color="inherit" href="https://rightio.co.uk/">
                {"RIGHTIO " + Version.getApplicationName()}
            </Link>{' '}
            {'.'}
        </Typography>
    );
}

export default React.memo(Copyright);